export default __webpack_public_path__ + "static/media/presion.646128c9.svg";